import { defineNuxtPlugin } from '#imports';
import { ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from '/var/lib/jenkins/workspace/taro-trip-production/node_modules/.pnpm/element-plus@2.8.1_vue@3.5.13_typescript@5.5.4_/node_modules/element-plus/es/index.mjs';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp
    .provide(ID_INJECTION_KEY, {"prefix":1024,"current":0})
    .provide(ZINDEX_INJECTION_KEY, {"current":0});
})
